import { Box, Grid, Tooltip } from "@mui/material";
import { Tab, Tabs } from "@vds/tabs";
import { Typography } from "@vds/typography";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as LiveIcon } from "../../../assets/LiveIconImg.svg";
import { PlayHLSVideo } from "../../../global/components/VideoPlayer";
import { VideoBox } from "../../../pages/Trends/Details/styles";
import "../../../styles/deviceStyle.css";
import "../cameraInfo.css";

const LiveFeed = React.memo(({
  liveFeedList
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [activeTab, setActiveTab] = useState(0);

  const getLiveChannels = () => {
    if (liveFeedList?.length > 0) {
      return liveFeedList?.map((item, index) => {
        return (
          <Tab
            className="live-feed__tab"
            selected={activeTab === index}
            key={index}
            label={<Tooltip
              placement="bottom-start"
              title={
                <div>
                  {String(item.name || '')}
                  <br />
                  {String(item?.customdata?.description || '')}
                </div>
              }
            >
              <div className="live-feed__tab-label">{String(item.name || '')}</div>
            </Tooltip>
            }
          >
            <Grid
              item
              xs={4}
              //borderBottom={showTopBox ? "solid silver" : "none"}
              p={1}
              className="font-face-vzb"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <VideoBox>
                  <PlayHLSVideo
                    liveFeedStream={item}
                    cameraRefidType={item.refidtype}
                    cameraQrcode={item.refid}
                  />
                </VideoBox>
              </Box>
            </Grid>
          </Tab >
        )
      })
    }
  }

  return (
    <Box border={"1px solid #A7A7A7"} borderRadius={2} margin={"5px"}>
      {liveFeedList?.length > 0 ? (
        <>
          <div className="devices live-feed__container">
            <div className="live-feed__icon-wrapper">
              <div className="live-feed__live-badge">
                <LiveIcon />
              </div>
            </div>
            <div className="live-feed__tabs-wrapper">
              <Tabs orientation="horizontal" indicatorPosition="bottom" >
                {getLiveChannels()}
              </Tabs>
            </div>
          </div>
        </>
      ) : (
        <Box>
          <div className="live-feed__empty-box">
            <Typography
              sx={{ fontWeight: 700, fontSize: "16px" }}
              fontWeight="600"
              paddingLeft={0.8}
            >
              Live Feed
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <VideoBox>
                  <PlayHLSVideo />
                </VideoBox>
              </Box>
            </Typography>
          </div>
        </Box>
      )}
    </Box>
  );
});

export default LiveFeed;
